import { render, staticRenderFns } from "./UserCollections.vue?vue&type=template&id=671c2cfe"
import script from "./UserCollections.vue?vue&type=script&lang=js"
export * from "./UserCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports